export enum FlexQueue {
  EVERYONE = 'Everyone',
  PRIORITY = 'Priority',
}
